export const CREATE_CONTACT_DETAIL = "CREATE_CONTACT_DETAIL";
export const FETCH_CONTACT_DETAIL = "FETCH_CONTACT_DETAIL";
export const FETCH_CONTACT_DETAILS = "FETCH_CONTACT_DETAILS";
export const EDIT_CONTACT_DETAIL = "EDIT_CONTACT_DETAIL";
export const DELETE_CONTACT_DETAIL = "DELETE_CONTACT_DETAIL";
